export default "__VITE_ASSET__qkfY2sOM__"